import { IsBoolean, IsOptional, Length } from 'class-validator';

export class ManufacturerUpdateModel {
  @Length(3, 128)
  public name: string;

  @IsBoolean()
  public active: boolean;

  @IsOptional()
  @Length(0, 36)
  public userId?: string;

  constructor(
    name: string,
    active: boolean,
    userId?: string
  ) {
    this.name = name;
    this.active = active;
    this.userId = userId;
  }
}
